// Export any javscript from here
export  {  Card }  from './mydex-design-system/components/card/card.js';
export  {  Referral }  from './mydex-design-system/components/referral/referral.js';
export  {  SPReferral }  from './mydex-design-system/components/referral/sp-referral.js';
export  {  CitizenReferralEvents } from './mydex-design-system/components/referral/citizen-referral-events.js';
export  {  Timeline }  from './mydex-design-system/components/timeline/timeline.js';
export  {  Table }  from './mydex-design-system/components/table/table.js';
export  {  Calendar }  from './mydex-design-system/components/calendar/calendar.js';
export  {  Group }  from './mydex-design-system/components/group/group.js';
export  {  Setup }  from './mydex-design-system/components/setup/setup.js';
export  {  Register }  from './mydex-design-system/components/register/register.js';
export  {  Index }  from './mydex-design-system/components/index/index.js';
export  {  Content }  from './mydex-design-system/components/content/content.js';
export  {  PasswordChange, PasswordReset }  from './mydex-design-system/components/password/password.js';
export  {  PDSTable }  from './mydex-design-system/pds/table/table.js';
export { Export } from './mydex-design-system/components/export/export.js';
export { PrivateKeyChange } from './mydex-design-system/components/private-key/private-key.js';
export  {  ProfileImage }  from './mydex-design-system/components/profile-image/profile-image.js';
export { RemoveConnection } from './mydex-design-system/components/remove-connection/remove-connection.js';
export { EmailChange } from './mydex-design-system/components/email/email.js';
export { Account } from './mydex-design-system/patterns/account/account.js';
export { LinkHandler } from './mydex-design-system/utilities/link-handler/link-handler.js';
export { Timezone } from './mydex-design-system/components/timezone/timezone.js';
export { Timeout } from './mydex-design-system/components/timeout/timeout.js';
export { Invites } from './mydex-design-system/components/invites/invites.js';
export { SSOM} from './mydex-design-system/ssom/ssom.js';
export { DatasetsView } from './mydex-design-system/components/datasets-view/datasets-view.js';
export { UploadFile } from './mydex-design-system/components/upload-file/upload-file.js';
export { SurveysFeedback } from './mydex-design-system/components/temp-form/SurveysFeedback.js';
export { SurveyGenerator } from './mydex-design-system/components/survey-generator/survey-generator.js';
export { Forms } from './mydex-design-system/pds/forms/forms.js';
export { UniqueURL } from './mydex-design-system/components/unique-invite-link/unique-invite-link.js';
export { Message } from './mydex-design-system/components/message/message.js';
export * from './mydex-design-system/components/message/referral-messages.js';
export  {  Services }  from './mydex-design-system/components/service-directory/services.js';
export  {  ServiceDirectory }  from './mydex-design-system/components/service-directory/service-directory.js';
export { MessagesAndAlerts } from './mydex-design-system/components/messages-and-alerts/messages-and-alerts.js';
export { Pacm } from './mydex-design-system/pds/pacm/pacm.js';
export { Login } from './mydex-design-system/components/login/login.js';
export { MFA } from './mydex-design-system/components/mfa/mfa.js';


// Import everything here so that when MydexDesignSystem is imported in an app, everything else is imported
import  { Card }   from "./mydex-design-system/components/card/card";
import  {  Referral }  from './mydex-design-system/components/referral/referral.js';
import  {  SPReferral }  from './mydex-design-system/components/referral/sp-referral.js';
import  {  CitizenReferralEvents } from './mydex-design-system/components/referral/citizen-referral-events.js';
import  {  Timeline }  from './mydex-design-system/components/timeline/timeline.js';
import  {  Table }  from './mydex-design-system/components/table/table.js';
import  {  Calendar }  from './mydex-design-system/components/calendar/calendar.js';
import  {  Group }  from './mydex-design-system/components/group/group.js';
import  {  Setup }  from './mydex-design-system/components/setup/setup.js';
import  {  Register }  from './mydex-design-system/components/register/register.js';
import  {  Index }  from './mydex-design-system/components/index/index.js';
import  {  Content }  from './mydex-design-system/components/content/content.js';
import  {  PasswordChange, PasswordReset }  from './mydex-design-system/components/password/password.js';
import  {  PDSTable }  from './mydex-design-system/pds/table/table.js';
import { Export } from './mydex-design-system/components/export/export.js';
import { PrivateKeyChange } from './mydex-design-system/components/private-key/private-key.js';
import  {  ProfileImage }  from './mydex-design-system/components/profile-image/profile-image.js';
import { RemoveConnection } from './mydex-design-system/components/remove-connection/remove-connection.js';
import { EmailChange } from './mydex-design-system/components/email/email.js';
import { Account } from './mydex-design-system/patterns/account/account.js';
import { LinkHandler } from './mydex-design-system/utilities/link-handler/link-handler.js';
import { Timezone } from './mydex-design-system/components/timezone/timezone.js';
import { Timeout } from './mydex-design-system/components/timeout/timeout.js';
import { Invites } from './mydex-design-system/components/invites/invites.js';
import { SSOM } from './mydex-design-system/ssom/ssom.js';
import { DatasetsView } from './mydex-design-system/components/datasets-view/datasets-view.js';
import { UploadFile } from './mydex-design-system/components/upload-file/upload-file.js';
import { SurveysFeedback } from './mydex-design-system/components/temp-form/SurveysFeedback.js';
import { SurveyGenerator } from './mydex-design-system/components/survey-generator/survey-generator.js';
import { Forms } from './mydex-design-system/pds/forms/forms.js';
import { UniqueURL } from './mydex-design-system/components/unique-invite-link/unique-invite-link.js';
import { Message } from './mydex-design-system/components/message/message.js';
import * as ReferralMessage from './mydex-design-system/components/message/referral-messages.js';
import  { Services }  from './mydex-design-system/components/service-directory/services.js';
import  { ServiceDirectory }  from './mydex-design-system/components/service-directory/service-directory.js';
import { MessagesAndAlerts } from './mydex-design-system/components/messages-and-alerts/messages-and-alerts.js';
import { Pacm } from './mydex-design-system/pds/pacm/pacm.js';


window.Card = Card;
window.Referral = Referral;
window.SPReferral = SPReferral;
window.CitizenReferralEvents = CitizenReferralEvents;
window.Timeline = Timeline;
window.Table = Table;
window.Calendar = Calendar;
window.Group = Group;
window.Register = Register;
window.Setup = Setup;
window.Index = Index;
window.Content = Content;
window.PDSTable = PDSTable;
window.PasswordChange = PasswordChange;
window.PasswordReset = PasswordReset;
window.Export = Export;
window.PrivateKeyChange = PrivateKeyChange;
window.ProfileImage = ProfileImage;
window.RemoveConnection = RemoveConnection;
window.EmailChange = EmailChange;
window.Account = Account;
window.LinkHandler = LinkHandler;
window.Timeout = Timeout;
window.Timezone = Timezone;
window.Invites = Invites;
window.SSOM = SSOM;
window.DatasetsView = DatasetsView;
window.UploadFile = UploadFile;
window.SurveysFeedback = SurveysFeedback;
window.SurveyGenerator = SurveyGenerator;
window.Forms = Forms;
window.UniqueURL = UniqueURL;
window.Message = Message;
window.ReferralMessage = ReferralMessage;
window.Services = Services;
window.ServiceDirectory = ServiceDirectory;
window.MessagesAndAlerts = MessagesAndAlerts;
window.Pacm = Pacm;


/**
 * MydexDesignSystem JS
 * Usage:
 * Usage:
 * import  { MydexDesignSystem }   from "@mydex/mydex-design-system";
 * window.addEventListener("load", MydexDesignSystem.init, false);
 */
export const MydexDesignSystem = (function () {
  /**
   * Initalise all components
   */
  var init = function () {
      Card.init();
      Referral.init();
      SPReferral.init();
      CitizenReferralEvents.init();
      Timeline.init();
      Table.init();
      Calendar.init();
      Group.init();
      Register.init();
      Setup.init();
      Index.init();
      PDSTable.init();
      PasswordChange.init();
      PasswordReset.init();
      Export.init();
      PrivateKeyChange.init();
      ProfileImage.init();
      RemoveConnection.init();
      EmailChange.init();
      Account.init();
      LinkHandler.init();
      Timeout.init();
      Timezone.init();
      Invites.init();
      SSOM.init();
      DatasetsView.init();
      UploadFile.init();
      SurveysFeedback.init();
      SurveyGenerator.init();
      Forms.init();
      UniqueURL.init();
      Message.init();
      Pacm.init
  }

  return {
    init : init
  }

}());

// Run Utility functions
LinkHandler.init()
